"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Voice = void 0;
class Voice {
    constructor(voice) {
        this.active = voice.active;
        this.altered = voice.altered;
        this.created = voice.created;
        this.meta_1 = voice.meta_1;
        this.meta_2 = voice.meta_2;
        this.name = voice.name;
        this.pri = voice.pri;
        this.sql_id = voice.sql_id;
        this.group = voice.group;
        this.hidden = voice.hidden;
        this.old_meta_1 = voice.old_meta_1;
        this.old_meta_2 = voice.old_meta_2;
        this.old_group = voice.old_group;
        this.querySnap = voice.querySnap;
        this.documentId = voice.documentId;
        this.ref = voice.ref;
    }
    async fromCollection(collection) {
        const collectionSnapshot = await collection.get();
        return this.fromDocumentSnapshotArray(collectionSnapshot.docs);
    }
    fromDocumentSnapshot(documentSnapshot) {
        return new Voice({
            ...documentSnapshot.data(),
            querySnap: documentSnapshot,
            documentId: documentSnapshot.id,
            ref: documentSnapshot.ref
        });
    }
    fromDocumentSnapshotArray(documentSnapshot) {
        return documentSnapshot.map(document => {
            return new Voice({
                ...document.data(),
                querySnap: document,
                documentId: document.id,
                ref: document.ref
            });
        });
    }
}
exports.Voice = Voice;
//# sourceMappingURL=Voice.js.map